module.exports = __webpack_public_path__ + "img/bg.1f76102d.png";